// extracted by mini-css-extract-plugin
export var blankTemplate = "blankTemplate-N4c";
export var body = "body-3QM";
export var cardGrid = "cardGrid-3iD";
export var cardGridTop = "cardGridTop-3l7";
export var button = "button-25t";